import Axios from "axios"
import CustomFormGroup from "components/Atoms/CustomFormGroup"
import CustomRadio from "components/Atoms/CustomRadio"
import CustomRadioGroup from "components/Atoms/CustomRadioGroup"
import Divider from "components/Atoms/Divider"
import StringInput from "components/Atoms/StringInput"
import DynamicSelector from "components/Molecules/DynamicSelector"
import FormController from "components/Molecules/FormController"
import { STATES } from "graphql/selector.queries.gql"
import React, { useEffect } from "react"
import styles from "./dc.module.scss"
import useDCStore from "./dc.store"
import FormLayout from "./FormLayout"
const BillingDetails = () => {
  const {
    billingDetails,
    errors,
    disabled,
    setBillingDetails,
    setAutoComplete,
  } = useDCStore(store => ({
    billingDetails: store.state.billingDetails,
    disabled: store.disabled,
    errors: store.errors.billingDetails?.details,
    setAutoComplete: store.setPinAutoComplete,
    setBillingDetails: store.setData("billingDetails"),
  }))
  const serverPin = billingDetails?.pincode
  const errorServerPin = errors?.pincode
  useEffect(() => {
    async function fetchPincodeDetails() {
      if (serverPin.length === 6 && !errorServerPin) {
        // The pincode is valid
        const response = await Axios.get(
          `https://kite-api-testing.vesatogo.in/services/rest/loacation_by_pincode/?pincode=${serverPin}`
        )
        if (response.status === 200) {
          setAutoComplete(response.data.location_by_pincode)
        }
      }
    }
    fetchPincodeDetails()
  }, [serverPin, errorServerPin, setAutoComplete])

  return (
    <FormController
      disableAll={true}
      disabled={disabled}
      errors={errors}
      source={billingDetails}
      onChange={setBillingDetails}
    >
      <FormLayout className={styles.grid} title="Tax Details">
        <CustomFormGroup
          className="vt-horizontal-radio-group"
          label="Enter Tax Details"
        >
          <CustomRadioGroup path="applicable">
            <CustomRadio name="Yes" id="yes" />
            <CustomRadio name="Not applicable" id="no" />
          </CustomRadioGroup>
        </CustomFormGroup>

        {billingDetails.applicable === "yes" && (
          <>
            <StringInput
              required
              path="gstin"
              type="Text"
              big={false}
              label="GSTIN"
              helperText="eg. 22AAAAA000A1Z5"
            />
            <StringInput
              required
              path="registeredName"
              type="Text"
              big={false}
              label="Registered Entity Name"
            />

            <StringInput
              required
              big={false}
              label="Business Place (SAP)"
              type="text"
              path="businessPlace"
            />
            <StringInput
              big={false}
              label="Profit Center"
              type="text"
              path="profitCenter"
            />
            <StringInput
              big={false}
              label="Cost Center"
              type="text"
              path="costCenter"
            />
          </>
        )}
      </FormLayout>
      {billingDetails.applicable === "yes" && <Divider className="mb-0" />}
      {billingDetails.applicable === "yes" && (
        <FormLayout title="Tax billing address" className={styles["grid"]}>
          <StringInput
            required
            path="pincode"
            maxLength={6}
            type="Text"
            big={false}
            label="Pin Code"
          />
          <DynamicSelector
            required
            query={STATES}
            label="State Name"
            path="state"
          />
          <StringInput
            required
            path="district"
            type="Text"
            big={false}
            label="District"
          />

          <StringInput
            required
            className={styles["codename"]}
            path="address1"
            type="Text"
            big={false}
            label="Address Line 1"
          />
          <StringInput
            required
            className={styles["codename"]}
            path="address2"
            type="Text"
            big={false}
            label="Address Line 2"
          />
        </FormLayout>
      )}
    </FormController>
  )
}

export default BillingDetails
